import anime from 'animejs';
import Scene from '../classes/scene';
import SceneManager from '../classes/scene-manager';
import { ScrollDirection } from '../classes/scroll-manager';
import { getEl } from '../helpers';

export default class DrillBits extends Scene {

	constructor(manager: SceneManager, targetContainer: string) {
		super(manager, targetContainer);


		this.addScrollAnimation({
			targets: this.elContainer.querySelector('.product-methanepointintstrument'),
			duration: 1500,
			delay: 0,
			left: ['-10%', '-2%'],
			easing: 'easeInOutSine',
		}, this.elContainer.querySelector('.mpi-scroller'), 300, 0, 1, 0.4, 0.5);
		
		
		this.addScrollAnimation({
			targets: getEl('.img-ora'),
			duration: 1500,
			delay: 0,
			left: ['50%', '35%'],
			easing: 'easeOutCubic',
		}, getEl('.ora-scroller'), 300, 0, 1, 0.2, 0.6);


	}

}
